import StarRating from "@/app/components/elements/StarRating";
import useProductDetail from "@/app/lib/features/productDetail/productDetail.hook";
import { Dot, Camera } from "lucide-react";
import Link from "next/link";
import { trackProductClick } from "@/app/lib/tracking/interactions";

const ProductRating = () => {
  const { product } = useProductDetail();

  if (!product?.rating) return null;

  const { rating } = product;

  return (
    <div className="flex items-center gap-1 sm:gap-2">
      {/* Rating Score */}
      <div className="flex items-center gap-2 sm:gap-2.5">
        <p className="text-sm sm:text-base font-semibold text-gray-900">
          {rating.average.toFixed(1)}
        </p>
        <StarRating
          rating={rating.average}
          size="sm"
          className="scale-100 sm:scale-110"
        />
      </div>

      {/* Separator Dot */}
      <Dot className="text-gray-400 shrink-0" size={20} />

      {/* Reviews Link */}
      <Link
        href={`/urun-degerlendirmesi/${product.slug}`}
        onClick={() => trackProductClick(product.id)}
        className="flex items-center gap-1 sm:gap-1.5 group transition-all duration-300 ease-in-out hover:text-main min-w-0"
      >
        <p className="text-xs sm:text-sm font-medium text-gray-900 whitespace-nowrap">
          {rating.count || 0}
        </p>
        <div className="flex items-center gap-1 min-w-0">
          <p className="text-xs sm:text-sm text-muted-foreground transition-all duration-300 ease-in-out group-hover:text-main truncate">
            {rating.text || "Değerlendirme"}
          </p>
          <Camera 
            size={14}
            className="w-3.5 sm:w-4 h-3.5 sm:h-4 shrink-0 text-muted-foreground transition-all duration-300 ease-in-out group-hover:text-main"
          />
        </div>
      </Link>
    </div>
  );
};

export default ProductRating;